import { isFuture, isToday } from "date-fns";
import { checkForEmptyNamesCamelCase } from "../../Sbb/helpers/checkForEmptyNames";
import { type MunichCityPassOffer, type MunichCityPassPassenger } from "../types";

export type MunichCityPassSeePriceValidationResult = {
  isValid: boolean;
  offerMissing: boolean;
  dateInPast: boolean;
  passengersMissing: boolean;
  hasInvalidNames: boolean;
};

export function validateMunichCityPassSeePrice(params: {
  selectedOffer: MunichCityPassOffer | null;
  selectedDate: Date;
  passengerList: MunichCityPassPassenger[];
}): MunichCityPassSeePriceValidationResult {
  const { selectedOffer, selectedDate, passengerList } = params;

  const offerMissing = !selectedOffer?.offer_code;
  const dateInPast = !(isToday(selectedDate) || isFuture(selectedDate));
  const passengersMissing = passengerList.length === 0;
  const hasInvalidNames = checkForEmptyNamesCamelCase(passengerList);

  return {
    isValid: !offerMissing && !dateInPast && !passengersMissing && !hasInvalidNames,
    offerMissing,
    dateInPast,
    passengersMissing,
    hasInvalidNames
  };
}
